(function () {
  var ROOT_SELECTOR = ".ko-installments";
  var PRICE_SELECTOR = "#js-product-price";

  var BANKS = [
    { id: "bankkart", label: "Bankkart Combo" },
    { id: "maximum", label: "Maximum" },
    { id: "axess", label: "Axess" },
    { id: "paraf", label: "Paraf" },
    { id: "qnb", label: "QNB" },
    { id: "bonus", label: "Bonus Card" },
    { id: "world", label: "World" },
    { id: "saglam", label: "Sağlam Kart" },
  ];

  var PLANS = [
    { count: 1, label: "Tek Çekim" },
    { count: 2, label: "2 Taksit" },
    { count: 3, label: "3 Taksit" },
    { count: 4, label: "4 Taksit" },
    { count: 6, label: "6 Taksit" },
    { count: 9, label: "9 Taksit" },
    { count: 12, label: "12 Taksit" },
  ];

  var RATES = {
    bankkart: { 1: 0, 2: 5.6, 3: 7.29, 4: 9.69, 6: 14.24, 9: 22.59, 12: 30.5 },
    maximum: { 1: 0, 2: 5.6, 3: 7.29, 4: 9.96, 6: 14.24, 9: 22.59, 12: 30.5 },
    axess: { 1: 0, 2: 5.6, 3: 7.29, 4: 9.96, 6: 14.24, 9: 22.59, 12: 30.5 },
    paraf: { 1: 0, 2: 5.6, 3: 7.29, 4: 9.96, 6: 14.24, 9: 22.59, 12: 30.5 },
    qnb: { 1: 0, 2: 5.6, 3: 7.29, 4: 9.96, 6: 14.24, 9: 22.59, 12: 30.5 },
    bonus: { 1: 0, 2: 5.6, 3: 7.29, 4: 9.96, 6: 14.24, 9: 22.59, 12: 30.5 },
    world: { 1: 0, 2: 5.6, 3: 7.29, 4: 9.96, 6: 14.24, 9: 22.59, 12: 30.5 },
    saglam: { 1: 0, 2: 5.6, 3: 7.29, 4: 9.69, 6: 14.24, 9: 22.59, 12: 30.5 },
  };

  function parsePriceFromText(text) {
    if (!text) return 0;
    var cleaned = String(text).replace(/[^\d,.]/g, "").trim();
    if (!cleaned) return 0;

    if (cleaned.indexOf(",") > -1) {
      cleaned = cleaned.replace(/\./g, "").replace(",", ".");
    } else if ((cleaned.match(/\./g) || []).length >= 1) {
      var parts = cleaned.split(".");
      if (parts.length > 1 && parts[parts.length - 1].length === 3) {
        cleaned = parts.join("");
      }
    }

    return parseFloat(cleaned) || 0;
  }

  function getBasePrice() {
    var priceEl = document.querySelector(PRICE_SELECTOR);
    if (priceEl) {
      var fromDom = parsePriceFromText(priceEl.textContent);
      if (fromDom > 0) return fromDom;
    }

    var root = document.querySelector(ROOT_SELECTOR);
    if (root && root.dataset.priceCents) {
      var cents = parseInt(root.dataset.priceCents, 10);
      if (!isNaN(cents) && cents > 0) return cents / 100;
    }

    return 0;
  }

  function formatMoney(amount) {
    return new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  function calcInstallmentAmount(basePrice, ratePercent, installmentCount) {
    var total = basePrice * (1 + ratePercent / 100);
    if (installmentCount <= 1) return total;
    return total / installmentCount;
  }

  function formatCell(amount, installmentCount) {
    if (installmentCount <= 1) {
      return formatMoney(amount);
    }
    return installmentCount + " x " + formatMoney(amount);
  }

  function renderTable(root) {
    var tbody = root.querySelector(".ko-installments__tbody");
    if (!tbody) return;

    var basePrice = getBasePrice();
    if (!basePrice) return;

    var rowsHtml = "";

    PLANS.forEach(function (plan) {
      rowsHtml += "<tr>";
      rowsHtml += '<th scope="row" class="ko-installments__plan">' + plan.label + "</th>";

      BANKS.forEach(function (bank) {
        var rate = RATES[bank.id][plan.count];
        var amount = calcInstallmentAmount(basePrice, rate, plan.count);
        rowsHtml += '<td data-bank="' + bank.id + '" data-plan="' + plan.count + '">';
        rowsHtml += formatCell(amount, plan.count);
        rowsHtml += "</td>";
      });

      rowsHtml += "</tr>";
    });

    tbody.innerHTML = rowsHtml;
  }

  function refreshAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(renderTable);
  }

  function bindPriceWatcher() {
    var priceEl = document.querySelector(PRICE_SELECTOR);
    if (!priceEl || priceEl.dataset.koInstallmentsWatch === "1") return;
    priceEl.dataset.koInstallmentsWatch = "1";

    var observer = new MutationObserver(function () {
      refreshAll();
    });

    observer.observe(priceEl, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  function init() {
    refreshAll();
    bindPriceWatcher();
  }

  document.addEventListener("click", function (event) {
    if (event.target.closest(".product-options__value, [data-js-product-option]")) {
      window.setTimeout(refreshAll, 150);
    }
  });

  document.addEventListener("DOMContentLoaded", init);
  window.setTimeout(init, 400);
})();
